import { SearchType } from '@search-bar/entities/search-type';
import { SearchBy } from '@shared/base-search-bar/entities/search.entities';

export function searchTypeToSearchBy(searchType: SearchType): SearchBy {
  if (searchType === SearchType.HOME_BUSES || searchType === SearchType.BUSES_RESULTS) {
    return SearchBy.BUSES;
  } else if (
    searchType === SearchType.HOME_HOTELS || searchType === SearchType.HOTELS_RESULTS || searchType === SearchType.HOTELS_DETAIL
  ) {
    return SearchBy.HOTELS;
  } else if (searchType === SearchType.PACKAGES_RESULT || searchType === SearchType.PACKAGES_HOME) {
    return SearchBy.PACKAGES;
  } else {
    return SearchBy.FLIGHTS;
  }
}
